import { LogManager } from '@mcleod/core';
import { AutogenLayoutMacroPointDataExportControl } from './autogen/AutogenLayoutMacroPointDataExportControl';

const log = LogManager.getLogger("lme/powerbroker/MacroPointDataExportControl");

export class MacroPointDataExportControl extends AutogenLayoutMacroPointDataExportControl {

    async postDataSources(): Promise<boolean> {
        let postToDataSource: boolean = false;
        try {
            if (this.mainDataSource?.hasChanged()) {
                await this.mainDataSource.post();
                postToDataSource = true;
            }
            return postToDataSource;
        } catch (error) {
            log.error(error);
            return postToDataSource;
        }
    }
}
